import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/nitrosamine-risk-assessment")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/nitrosamine-risk-assessment", statusCode: 301 }); },
});
